import { getAppEnvironment, Environment } from '@/config';
import { useExternalScript } from '../../../../hooks/useExternalScript';

/**
 * PaymentScripts
 * Loads the PortalOne payment script exactly once application-wide.
 * Multiple pages/components include this component. The hook guarantees idempotent, cached loading.
 */
export const PaymentScripts = () => {
  const src =
    getAppEnvironment() === Environment.Prod
      ? 'https://portalone.processonepayments.com/GenericModalV2/PortalOne.js'
      : 'https://stgportalone.processonepayments.com/GenericModalV2/PortalOne.js';

  useExternalScript(src, {
    id: 'portalone-script',
    retryCount: 1,
    retryDelayMs: 1500,
    onError: (e: unknown) => console.error('[PaymentScripts] PortalOne script failed', e),
  });

  return null;
};
